import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useMailPreferences } from '../context/MailPreferencesContext';
import { bootstrapDesktopNotifications } from '../utils/desktopNotifications';

/**
 * Stellt SW + Web-Push-Abo her, sobald Login + Browser-Berechtigung da sind.
 * Sonst fehlt das Abo nach Reload und Hintergrund-Push bleibt stumm.
 */
export default function DesktopNotificationBootstrap() {
  const { isAuthenticated } = useAuth();
  const { preferences } = useMailPreferences();

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    if (preferences.desktopNotifications === false) return undefined;

    let cancelled = false;
    const run = () => {
      if (cancelled) return;
      bootstrapDesktopNotifications({ enabled: true }).catch(() => {});
    };

    run();
    const onVis = () => {
      if (document.visibilityState === 'visible') run();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [isAuthenticated, preferences.desktopNotifications]);

  return null;
}
